<template>
  <NominateForm
    ref="NominateForm"
    class="content"
    :invalid="isSubmitting"
    @submit="submit"
    @submit-and-pay="submitAndPay"
  />
</template>

<script>
import NominateForm from '@/components/NominateForm'
import { createNomination } from '@/services/HttpSvc'
import { USER_NOMINATIONS, USER_NOMINATION_EDIT, USER_NOMINATIONS_PAYMENT } from '@/core/constants'

export default {
  name: 'EditNomination',

  components: {
    NominateForm,
  },

  data() {
    return {
      isSubmitting: false,
    }
  },

  methods: {
    async submitNomination(formData, successRedirectUrl) {
      this.isSubmitting = true
      try {
        const nominationId = await createNomination(formData)
        const uploadFilesResp = await this.$refs.NominateForm.uploadFiles(nominationId)

        if (uploadFilesResp.failed.length >= 1) {
          //console.error('File upload failed! uploadFilesResp: ', uploadFilesResp)
          window.location = `${USER_NOMINATION_EDIT(nominationId)}?fileUploadFailed=${uploadFilesResp.failed.length}`
        } else {
          //console.debug('File upload success! uploadFilesResp: ', uploadFilesResp)
          window.location = successRedirectUrl
        }
      } catch(err) {
        //console.error('nomination failed', err)
        this.isSubmitting = false
      }
    },

    async submit(formData) {
      await this.submitNomination(formData, `${USER_NOMINATIONS}?fileUploadSuccessful=true`)
    },

    async submitAndPay(formData) {
      await this.submitNomination(formData, USER_NOMINATIONS_PAYMENT)
    },
  },
}
</script>
